import * as yup from 'yup';
import { UseFormProps } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { reEmail, rePhone } from '@shared/lib/regex';
import { IContactDetails } from '@entities/employee';
import {
  INVALID_EMAIL,
  INVALID_PHONE_NUMBER,
  REQUIRED_EMAIL,
} from '@modules/employees/shared/constants/form-error.constants';

export type FormDataType = IContactDetails;

const schema = yup
  .object()
  .shape({
    corporateMail: yup.string().required(REQUIRED_EMAIL).matches(reEmail, INVALID_EMAIL),
    phoneNumber: yup.object().shape({
      phone: yup
        .string()
        .matches(rePhone, {
          excludeEmptyString: true,
          message: INVALID_PHONE_NUMBER,
        })
        .default(''),
      code: yup.string().default(''),
    }),
    payoneerID: yup.string().default('').required('Payoneer ID is required'),
  })
  .required();

export const setup = (defaultValues: FormDataType) => {
  const { phone, code } = defaultValues.phoneNumber;

  defaultValues.phoneNumber.phone = code + phone;

  const options: UseFormProps<FormDataType> = {
    defaultValues,
    resolver: yupResolver<FormDataType>(schema),
  };

  return {
    options,
  };
};
